// extracted by mini-css-extract-plugin
export var modal = "_45-0";